import React, { Component } from "react";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class DeletePopUp extends Component {
  static contextType = PopUpContext;

  handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const {
        togglePopUp,
        popUp: { route, id },
      } = this.context;

      await db
        .delete(route, id)
        .then(() => {
          togglePopUp({ form: "toast", message: "حذف گردید." });
        })
        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { togglePopUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{lbl.AreYouSure}</p>
          </div>
          <div className="form-paragraphs">
            <p>تمام اطلاعات مربوطه حذف میگردد و قابل برگشت نمیباشد.</p>
          </div>
          <div className="form-buttons">
            <button>{lbl.Yes}</button>
            <button type="button" onClick={() => togglePopUp()}>
              {lbl.Cancel}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default DeletePopUp;
